module.exports = __webpack_public_path__ + "media/images/app/term-d4fe99a72d7e94d6e21d61f49beaaf45.svg";